import { Title } from '../../utils/title';
import Layout from './Layout';
import styles from './Cookies.module.scss';

const Cookies = () => {
  return (
    <Layout>
      <div className={styles.root}>

        <Title value='Cookie Policy' />

        {
          /*
           * BEGIN HTML
           */
        }
        <div className="d-flex justify-content-center align-items-center">
          <h1 className="card-title text-muted text-black">COOKIE POLICY</h1>
        </div>
        <p className="card-text">
          This Cookie Policy explains how www.chimeable.com ("we", "us", "our") uses cookies and
          similar technologies on our website. By using our website, you consent to our use of
          cookies in accordance with this Cookie Policy.
        </p>
        <h2 className="card-text font-weight-bold">What are cookies?</h2>
        <p className="card-text">
          Cookies are small data files that are placed on your device when you visit a website.
          They allow the website to recognize your device and store information about your
          preferences or past actions.
        </p>
        <h2 className="card-text font-weight-bold">
          Cookies can be divided into different categories:
        </h2>
        <p className="card-text">
          Cookies are small data files that are placed on your device when you visit a website.
          They allow the website to recognize your device and store information about your
          preferences or past actions.
          <ul>
            <li>
              Strictly necessary cookies: These cookies are essential for the operation of our
              website and cannot be turned off. They do not store any personally identifiable
              information.
            </li>
            <li>
              Functional cookies: These cookies enable the website to provide enhanced
              functionality and personalization. They may store information about your preferences
              or past actions.
            </li>
            <li>
              Analytical cookies: These cookies collect information about how visitors use our
              website, such as which pages they visit most often. This helps us improve our
              website and provide a better user experience.
            </li>
            <li>
              Advertising cookies: These cookies are used to deliver advertisements that are more
              relevant to you and your interests. They may also be used to limit the number of
              times you see an advertisement and measure the effectiveness of advertising
              campaigns.
            </li>
          </ul>
        </p>
        <h2 className="card-text font-weight-bold">How do we use cookies?</h2>
        <p className="card-text font-weight-bold"><b>We use cookies for the following purposes:</b></p>
        <p className="card-text">
          <ul>
            <li>
              To operate our website: We use strictly necessary cookies to provide basic website
              functionality, such as remembering your login details or shopping cart items.
            </li>
            <li>
              To personalize your experience: We use functional cookies to remember your
              preferences or past actions, such as your language or region.
            </li>
            <li>
              To analyze website usage: We use analytical cookies to collect information about how
              visitors use our website, such as which pages they visit most often. This helps us
              improve our website and provide a better user experience.
            </li>
            <li>
              To deliver personalized advertising: We use advertising cookies to deliver
              advertisements that are more relevant to you and your interests. We do not share
              your personal information with advertisers.
            </li>
          </ul>
        </p>
        <h2 className="card-text font-weight-bold">What cookies do we use?</h2>
        <p className="card-text font-weight-bold"><b>We use the following cookies on our website:</b></p>
        <p className="card-text">
          <ul>
            <li>Functional cookies: loginCookie, cookieNotice</li>
            <li>
              Analytical cookies: _ga (Google Analytics cookie
              https://developers.google.com/analytics/devguides/collection/analyticsjs/cookie-usage)
            </li>
          </ul>
        </p>

        <h2 className="card-text font-weight-bold">Third-party cookies</h2>
        <p className="card-text">
          We use third-party cookies on our website. These cookies are placed by third-party
          service providers and are used to collect information about your browsing habits across
          different websites and services. This information is used to provide targeted
          advertising and for other purposes, such as website analytics. Third-party cookies are
          subject to the privacy policies of the third-party service providers..
        </p>

        <h2 className="card-text font-weight-bold">How can you control cookies?</h2>
        <p className="card-text">
          You can control the use of cookies on our website through your browser settings. Most
          browsers allow you to block or delete cookies, or to configure your preferences for
          certain websites. Please note that if you choose to block or delete cookies, some parts
          of our website may not function properly.
        </p>

        <h2 className="card-text font-weight-bold">Changes to this Cookie Policy</h2>
        <p className="card-text">
          We may update this Cookie Policy from time to time. We will post any changes on our
          website and update the effective date at the top of this policy. We encourage you to
          review this policy periodically to stay informed about our use of cookies.
        </p>
        <h2 className="card-text font-weight-bold">Contact us</h2>
        <p className="card-text">
          If you have any questions about this cookie policy, please contact us at
          privacy@chimeable.com.
        </p>
        <div className="d-flex justify-content-center align-items-center">
          <p> Copyright © 2025. Chimeable Inc.</p>
        </div>
        <div className="d-flex justify-content-center align-items-center">
          <p> All Rights Reserved.</p>
        </div>
        <div className="d-flex justify-content-center align-items-center">
          <p> Last updated: March 13, 2023</p>
        </div>
        {
          /*
           * END HTML
           */
        }

      </div>
    </Layout>
  );
};

export default Cookies;